import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AppConstants, AuthenticationService} from 'app/api/authentication.service';
import {FormControl, FormGroupDirective, NgForm, Validators, FormGroup, FormBuilder} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Subject, tap} from 'rxjs';
import {map, take} from 'rxjs/operators';
import jwtDecode from 'jwt-decode';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject<void>();
  model: any = {username: '', password: ''};
  unrecognized = false;
  returnUrl: string;
  hide = true;
  validForm = false;
  public isMobile: boolean;


  emailFormControl = new FormControl(this.model.username, [
    Validators.required,
    Validators.email,
  ]);

  passwordFormControl = new FormControl(this.model.password, [
    Validators.required,
    Validators.minLength(2)
  ]);

  public loginForm = this.formBuilder.group({
    email: this.emailFormControl,
    password: this.passwordFormControl,
  });

  matcher = new MyErrorStateMatcher();


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder
    /*private alertService: AlertService*/) {
  }

  ngOnInit(): void {

    this.isMobile = (window.innerWidth <= 700);
    window.onresize = () => this.isMobile = (window.innerWidth <= 700);
    // reset login status
    this.authenticationService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard/resources';
    console.log('returnUrl', this.returnUrl);
    this.loginForm.statusChanges.subscribe((status) => {
      this.unrecognized = false;
      this.validForm = status === 'VALID';
    });


    window.google.accounts.id.renderButton(
      document.getElementById('g_id_onload'),
      { theme: 'outline', size: 'large', width: 260, text: 'continue_with' }
    );
  }



  login(): void {
   const obs$ = this.authenticationService.login(this.model.username, this.model.password)
      .pipe(
        map((jwt: string) => { return jwt; }),
        tap((jwt: string) => {
          console.log('get the jwt as is');
          console.log('jwt', jwt);
          console.log('router', this.router);
          localStorage.removeItem('currentUser');
          localStorage.removeItem('token');
          localStorage.clear();
          // login successful if there's a jwt token in the response
          const decoded: any = jwtDecode(jwt.toString());
          console.log('testing decding values');
          console.log('#####', decoded);
          if (jwt && decoded.id) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', decoded.id);
            localStorage.setItem('token', jwt.toString());
            console.log('redirecting to', this.returnUrl);
            this.router.navigateByUrl(this.returnUrl || '/dashboard/testlist');
          }
        }
      ));

      obs$.subscribe({
        error(err) {
          console.error('something wrong occurred: ' + err);
          this.unrecognized = true;
        }
      });
  }

  linkedinLogin() {
    console.log(AppConstants.LINKEDIN_AUTH_URL);
    window.location.href = AppConstants.LINKEDIN_AUTH_URL;
  }

  googleLogin() {
    console.log(AppConstants.GOOGLE_AUTH_URL);
    window.location.href = AppConstants.GOOGLE_AUTH_URL;
  }

  githubLogin() {
    console.log(AppConstants.GITHUB_AUTH_URL);
    window.location.href = AppConstants.GITHUB_AUTH_URL;
  }


  goToResetPwd() {
    this.router.navigateByUrl('login/password-reset');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}


export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
